import JobWorkerDto from '@/models/JobWorkers/JobWorkerDto';
import JobWorkerTabIndex from '@/models/JobWorkers/JobWorkerTabIndex';
import JobWorkerInterviewDto from '@/models/JobWorkerInterviews/JobWorkerInterviewDto';
import JobWorkerOfferDto from '@/models/JobWorkerOffers/JobWorkerOfferDto';

export default class JobWorkersViewModel {
    currentTabIndex: JobWorkerTabIndex = -1
    selectedWorkerId = '';
    selectedShortlistedJobWorker: JobWorkerDto = null;
    selectedInterestedJobWorker: JobWorkerDto = null;
    selectedInterviewingJobWorker: JobWorkerDto = null;
    selectedOfferJobWorker: JobWorkerDto = null;
    selectedPlacedJobWorker: JobWorkerDto = null;
    selectedJobWorkerInterviewForInterviewingTab: JobWorkerInterviewDto = null;
    selectedJobWorkerInterviewForOffersTab: JobWorkerInterviewDto = null;
    selectedJobWorkerInterviewForPlacedTab: JobWorkerInterviewDto = null;
    selectedJobWorkerInterviewForRejectedTab: JobWorkerInterviewDto = null;
    selectedJobWorkerOfferForInterviewingTab: JobWorkerOfferDto = null;
    selectedJobWorkerOfferForOffersTab: JobWorkerOfferDto = null;
    selectedJobWorkerOfferForPlacedTab: JobWorkerOfferDto = null;
    selectedJobWorkerOfferForRejectedTab: JobWorkerOfferDto = null;
    selectedRejectedJobWorker: JobWorkerDto = null;
    jobWorkers: JobWorkerDto[] = [];
    inviteUrl = '';
}